import { lazy } from 'react';

const LazyUserManagementView = lazy(() => import('./user-management-view'));
export default LazyUserManagementView;
